module.exports = __webpack_public_path__ + "05_hair_brown.43caa2eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/05_hair_brown.png
// module id = 4uTO
// module chunks = 0